/**
 * Route for `cross-channel-attribution`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CrossChannelAttributionPage } from "../features/cross-channel-attribution/CrossChannelAttributionPage";

export const crossChannelAttributionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cross-channel-attribution",
	component: CrossChannelAttributionPage,
});

export default crossChannelAttributionRoute;
